export const usePluginReviseProduct = () => {
    const extensions = () => {
        return {
            canReviseProduct() {
                if (! this.permission.has('revise')) {
                    this.logger.error('没有修订权限')
                    return false
                }

                const bn = this.BizNode[this.componentType ?? this.productType]

                if ('function' !== typeof bn.revise) {
                    this.logger.error('不支持修订')
                    return false
                }

                const {stsCode} = this.root.data

                if ('RLS' !== stsCode) {
                    this.logger.error('只有发布状态才能修订')
                    return false
                }

                return true
            },

            async cmdReviseProduct() {
                await this.runAction(
                    () => this.execute(
                        () => this.reviseProduct()
                    ),

                    {action: '修订模型制品'},
                )
            },

            async reviseProduct() {
                const bn = this.BizNode[this.componentType ?? this.productType]
                await bn.revise(this, this.root)
                this.resetChangeHistory()
            },

            useCanReviseProduct() {
                this.usePermission()
                this.useNodeChange(this.root, ['data'])
                return this.canReviseProduct()
            },
        }
    }

    return {extensions}
}
